import styled from 'styled-components';

const ReportDateSettingsWrapper = styled.div`
  background-color: ${(props): string => props.theme.colors.iceGray};
  margin-top: 2rem;
  margin-bottom: 2rem;
  padding: 1.5rem;
  border: 1px solid #b4c2d1;
  border-radius: 0.7rem;
`;

export { ReportDateSettingsWrapper };
